import React, { Component } from 'react';
import reject from 'lodash/reject';
import * as yup from 'yup';
import { Select, Modal, Button, Table, DatePicker, Popconfirm, message, Collapse } from 'antd';
import GoogleMapReact from 'google-map-react';
import { Rate } from 'antd';
import {isEmpty, map} from "lodash";
import moment from 'moment-timezone';

import DataTable from '../../../../Assets/data/Datatable';
import peeking_doodle from '../../../../Assets/images/useraccount/peeking_doodle.svg';
// import abt from '../../../../Assets/images/subscription_about_img.png';
import chevron from '../../../../Assets/images/chevron.svg';
import trash from '../../../../Assets/images/grey-trash.png';
import pin from '../../../../Assets/images/useraccount/pin.png';
import sort from '../../../../Assets/images/sorticon.png';
import Path from '../../../../Assets/images/Path.svg';
import CustomMap from "./CustomMap";
// import CustomerPortalMap from '../../../../Assets/images/CustomerPortalMap.png';

let MarkePin = () => <div className="marker_wrapper"> <img style={{ 'width': '15px' }} src={pin} alt="" className="pin" /><div className="pulse" /></div>



const { Option } = Select;
const { Panel } = Collapse;

// maping frequency for hardcoded
const FREQUENCY_MAPPING = {
  weekly: 'Weekly',
  bi_monthly: 'Every Other Week',
  once: 'Just Once',
  twice_weekly: 'Twice Weekly',
  monthly: 'Monthly'
};

// maping frequency  for hardcoded
const PROPERTY_TYPE_MAPPING = {
  townhouse: 'Town House',
  single_family_small: 'Detached (Less than 0.75 acre)',
  single_family_large: 'Detached (More than 0.75 acre)',
  commercial: "Commercial"
}
//Commercial Service
const status2 = {
  pet_waste_station_service: "Pet Waste Station Service",
  common_area_cleaning: "Common Area Cleaning",
  trash_can_service: "Trash Can Service",
  pet_waste_stations: "Pet Waste Stations",
  pet_waste_station_bags: "Pet Waste Station Bags",
}


class MyServices extends Component {
  state = {
    invoice_pagination: { showSizeChanger: false, pageSize: 10, ordering: "scheduled_time" },
    is_feedback: false,
    is_pause_service: false,
    view_my_service: false,
    loader: false,
    is_pause_service_checked: false,
    suspend_until_manual: false,
    is_submit_btn_active: false,
    ServiceData: [],
    viewMyService: [],
    currentService: [],
    pauseServiceList: [],
    current_history: {},
    feedback: { 'rating': 0, 'comment': '' },
    pause_service: {
      'pause_from': null,
      'pause_to': null,
      'suspend_until_manual': false,
      'understand_pause_func': false
    },
    role: [],
    temp_hide_specific_elmement:false,
  }

  componentDidMount = () => {

    let userKey = JSON.parse(localStorage.getItem('userKey')) || null;
    if (userKey) {
      this.setState({
        role: userKey?.user?.role
      })

    }




    //Call service order API
    // this.props.getServiceOrder();
    this.setState({
      loader: true
    })
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 300);

    // get pause service
    let is_pause_service = JSON.parse(localStorage.getItem('is_pause_service')) || null;
    if (is_pause_service) {
      this.setState({
        currentService: is_pause_service.service_order__uuid,
        service_address: is_pause_service.service_address,
        is_pause_service: true,
        loader: true
      });
      this.ValidateForm();
      // API call for service details
      this.props.ViewService({ ordering: this.state.invoice_pagination.ordering, 'service_order__uuid': is_pause_service.service_order__uuid, 'limit': 10, 'offset': 0 });
      this.props.getPauseService({ 'service_order__uuid': is_pause_service.service_order__uuid });


    }

    //get view service
    let is_view_service = JSON.parse(localStorage.getItem('is_view_service')) || null;
    if (is_view_service) {
      this.setState({
        currentService: is_view_service.service_order__uuid,
        service_address: is_view_service.service_address,
      });
      this.props.ViewService({ ordering: this.state.invoice_pagination.ordering, service_order__uuid: is_view_service.service_order__uuid, 'limit': 10, 'offset': 0 });
    }

    //clear local storage extra item
    localStorage.removeItem('is_pause_service');
    localStorage.removeItem('is_view_service');
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    const invoice_pagination = { ...this.state.invoice_pagination };
    let { currentService } = this.state;

    // Service Order details
    if (Object.keys(props.serviceOrder.data).length > 0 && props.serviceOrder.data !== this.props.serviceOrder.data) {
      this.setState({
        ServiceData: props.serviceOrder.data.results,
        loader: false
      })
    }
    if (Object.keys(props.serviceOrder.errors).length > 0 && props.serviceOrder.errors !== this.props.serviceOrder.errors) {
      // display error messsage
      this.setState({
        loader: false
      })
    }
    // Service Order details
    if (Object.keys(props.viewMyService.data).length > 0 && props.viewMyService.data !== this.props.viewMyService.data) {

      invoice_pagination.total = props.viewMyService.data.count;
      this.setState({
        viewMyService: props.viewMyService.data.results,
        view_my_service: true,
        invoice_pagination,
        loader: false
      })
    }
    if (Object.keys(props.viewMyService.errors).length > 0 && props.viewMyService.errors !== this.props.viewMyService.errors) {
      // display error messsage
      this.setState({
        loader: false
      })
    }
    // Pause Service
    if (Object.keys(props.servicePause.data).length > 0 && props.servicePause.data !== this.props.servicePause.data) {
      this.setState({
        // is_pause_service: false,
        pause_service: {
          'pause_from': null,
          'pause_to': null,
          'suspend_until_manual': false,
          'understand_pause_func': false
        },
        is_pause_service_checked: false,
        loader: false
      })
      this.props.ViewService({ ordering: this.state.invoice_pagination.ordering, 'service_order__uuid': currentService, 'limit': 10, 'offset': 0 });
      this.props.getPauseService({ 'service_order__uuid': this.state.currentService });
    }
    if (Object.keys(props.servicePause.errors).length > 0 && props.servicePause.errors !== this.props.servicePause.errors) {
      // display error messsage
      map(props.servicePause.errors, (item) => {
        message.error(item)
      })

      this.setState({
        loader: false
      })

    }
    // get Pause Service list
    if (Object.keys(props.pauseServiceList.data).length > 0 && props.pauseServiceList.data !== this.props.pauseServiceList.data) {
      this.setState({
        pauseServiceList: props.pauseServiceList.data.upcoming,
        loader: false
      });

    }
    if (Object.keys(props.pauseServiceList.errors).length > 0 && props.pauseServiceList.errors !== this.props.pauseServiceList.errors) {
      // display error messsage
      this.setState({
        loader: false
      })
    }

    // delete Pause Service
    if (Object.keys(props.pauseServiceDeleted.data).length > 0 && props.pauseServiceDeleted.data !== this.props.pauseServiceDeleted.data) {
      // Delete Service message
      this.setState({
        loader: false
      })
      this.props.ViewService({ ordering: this.state.invoice_pagination.ordering, 'service_order__uuid': currentService, 'limit': 10, 'offset': 0 });
    }
    if (Object.keys(props.pauseServiceDeleted.errors).length > 0 && props.pauseServiceDeleted.errors !== this.props.pauseServiceDeleted.errors) {
      // display error messsage
      this.props.getPauseService();
      this.setState({
        loader: false
      })
    }

    // get Pause Service list
    if (Object.keys(props.addReview.data).length > 0 && props.addReview.data !== this.props.addReview.data) {
      this.props.ViewService({ ordering: this.state.invoice_pagination.ordering, 'service_order__uuid': this.state.currentService, 'limit': 10, 'offset': 0 });
      this.setState({ is_feedback: false, current_history: {}, feedback: { 'rating': 0, 'comment': '' }, loader: false });
    }
    if (Object.keys(props.addReview.errors).length > 0 && props.addReview.errors !== this.props.addReview.errors) {
      // display error messsage
      message.destroy();
      map(props.addReview.errors, (item, key) => {
        message.error(`${key}::${item}`);
      })
      this.setState({
        loader: false
      })
    }

    this.setState({loader: false});
  }




  //Render Commercial Map
  renderCommercialMap = (item) => {
    let MAP_OPTIONS = { disableDoubleClickZoom: true, zoomControl: false, mapTypeControl: false, scaleControl: false, streetViewControl: false, rotateControl: false, fullscreenControl: false }
    if (item.length > 0) {
      return (
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY }}
          options={MAP_OPTIONS}
          defaultCenter={{ lat: parseFloat(item[0].latitude), lng: parseFloat(item[0].longitude) }}
          defaultZoom={14}
        >
          {
            map(item, (x, i) => {
              return (<MarkePin
                key={i}
                lat={parseFloat(x.latitude)}
                lng={parseFloat(x.longitude)}
              />)
            })
          }
        </GoogleMapReact>
      )
    }

  }
  //Render All Serivce
  renderAllService = () => {
    let { ServiceData, role } = this.state;

    return map(ServiceData && ServiceData, (item, i) => {
      let _markers = [], multiple_locations = item?.commercial_detail?.multiple_locations, address = item?.service_address
      if (multiple_locations && multiple_locations !== "None") {
        let locations = multiple_locations?.split('MULTIPOINT')[1]
        locations = locations?.trim().substr(1, locations.trim().length - 2)
        let temp = locations?.split(', ')
        map(temp, (obj) => _markers.push({ lat: obj.split(' ')[0], lng: obj.split(' ')[1] }))
      } else if (!isEmpty(address) && !isEmpty(address?.geo_location)) {
        _markers = [{ lat: address?.geo_location?.latitude, lng: address?.geo_location?.longitude }]
      }

      const cleaning_areas = item?.calculated_price?.cleaning_areas;
      let arr_cleaning_area = [];
      if (!isEmpty(cleaning_areas) && !isEmpty(cleaning_areas.items)) {
        map(cleaning_areas.items, (item) => {
          if (item.price !== 0) {
            arr_cleaning_area.push(item.area);
          }        
        });
      }

      let frequency = [];
      map(item?.frequency_type?.split(', '), x => x && frequency.push(FREQUENCY_MAPPING[x]))

      return (
        <React.Fragment key={i}>
          {role.includes('commercial_customer') ?

            <div className="col-md-12 col-xl-4 col-lg-4 mb-20" key={i}>
              <div className="ccard h-100">
                {
                  !isEmpty(_markers) ?
                    <div className="cmap">
                      <CustomMap markers={_markers} />
                    </div> : ''
                }
                <div className="cbody">
                  <h5>
                    <span className="adpin"></span>&nbsp; &nbsp;
                    <span>{item.service_address?.address},{item.service_address?.city},{item.service_address?.state} {item.service_address?.zip_code}</span>
                  </h5>
                  <div className="sdetail d-flex ">
                    <div className="scell">
                      <strong>Next Service</strong>
                      <p> {item.next_service_date ? moment(item.next_service_date).format('ddd, MMM DD') : ''}</p>
                    </div>
                    <div className="scell">
                      <strong>Frequency</strong>
                      <p>{!isEmpty(frequency) ? frequency?.join(', ') : ''}</p>

                    </div>
                    <div className="scell">

                      <strong>Last Service</strong>
                      <p>{item.next_service_date ? moment(item.next_service_date).format('ddd, MMM DD') : ''}</p>

                    </div>
                  </div>
                  <div className="sdetail">
                    <div className="subs">
                      <strong>Subscription</strong>
                      <span className=" d-flex justify-content-between">
                        <div>
                          {
                            map(item?.commercial_detail?.line_items, (x, i) => {
                              return (
                                <p key={i} className="mb-0">{`${x.frequency ? FREQUENCY_MAPPING[x.frequency] : ''}${x.frequency ? ' Service, ' : ''} ${status2[x.item]}`}</p>
                              )
                            })
                          }
                        </div>


                        <strong>${item?.commercial_detail?.total}</strong>
                      </span>
                    </div>

                  </div>
                  <div className="vtotal  d-flex justify-content-between">
                    <strong>Total per visit</strong>
                    <strong>${item?.commercial_detail?.total}</strong>
                  </div>
                  <div className="btn-grp">

                    <button
                      type="button"
                      onClick={() => {
                        this.setState({
                          currentService: item?.uuid,
                          service_address: ServiceData[i]['service_address'],
                          loader: true
                        });

                        this.props.ViewService({ ordering: this.state.invoice_pagination.ordering, service_order__uuid: item?.uuid, limit: 10, offset: 0, is_history:true });
                      }}
                      className="btn btn--secondary w-100">View Service </button>
                  </div>
                </div>
              </div>
            </div >
            :

            <div className="col-md-12 col-xl-4 col-lg-4 mb-20" key={i}>
              <div className="ccard h-100">
                <React.Fragment>
                  {
                    item.service_address.geo_location ?
                      <div className="cmap">
                        {this.renderMap(item)}
                      </div>
                      : ''
                  }

                </React.Fragment>

                <div className="cbody">
                  <h5>
                    <span className="adpin"></span>&nbsp; &nbsp;
                    <span>{item.service_address.address},{item.service_address.city},{item.service_address.state} {item.service_address.zip_code}</span>
                  </h5>
                  <div className="sdetail d-flex ">
                    <div className="scell">
                      <strong>Next Service</strong>
                      <p> {item.next_service_date ? moment(item.next_service_date).format('ddd, MMM DD') : ''}</p>
                    </div>
                    <div className="scell">
                      <strong>Frequency</strong>
                      <p>{FREQUENCY_MAPPING[item.calculated_price.frequency] && FREQUENCY_MAPPING[item.calculated_price.frequency]}</p>

                    </div>
                    <div className="scell">

                      <strong># of Dogs</strong>
                      <p>{item.calculated_price.pet_count}</p>

                    </div>
                  </div>
                  <div className="sdetail">
                    <div className="subs">
                      <strong>Subscription</strong>
                      <span className=" d-flex justify-content-between">
                        <p>
                          {FREQUENCY_MAPPING[item.calculated_price.frequency]}&nbsp; service, {PROPERTY_TYPE_MAPPING[item.calculated_price.property_type] && PROPERTY_TYPE_MAPPING[item.calculated_price.property_type]}, {item.calculated_price.pet_count} dogs</p>
                        <strong>${item.calculated_price.service_base_price}</strong>
                      </span>
                    </div>
                    <div className="subs">
                      <strong>Cleaning Areas</strong>
                      <span className=" d-flex justify-content-between">
                        <p>{arr_cleaning_area.length > 0 ? arr_cleaning_area.join(', ') : 'NA'}</p>
                        <strong>${item?.calculated_price?.cleaning_areas?.total_price}</strong>
                      </span>
                    </div>

                    <div className="subs">
                      <strong>Add On</strong>
                      <span className=" d-flex justify-content-between">

                        {item.calculated_price.recurring_add_ons.recurring_addon_items.length > 0 ?
                          <React.Fragment>
                            <p>
                              {map(item.calculated_price.recurring_add_ons
                                && item.calculated_price.recurring_add_ons.recurring_addon_items, (a) => {
                                return `${a.name}, `
                              })}
                        ({FREQUENCY_MAPPING[item.calculated_price.frequency]})
                            </p>
                            <strong>${item.calculated_price.recurring_add_ons.total_recurring_addon_cost}</strong>
                          </React.Fragment> : '-'}

                      </span>
                    </div>

                  </div>
                  <div className="vtotal  d-flex justify-content-between">
                    <strong>Total per visit</strong>
                    <strong>${item.calculated_price.total_price_per_service}</strong>
                  </div>
                  <div className="btn-grp">
                    <button type="button" className="btn btn--secondary w-100"
                      onClick={() => {
                        this.setState({
                          currentService: ServiceData[i]['uuid'],
                          service_address: ServiceData[i]['service_address'],
                          loader: true
                        });

                        this.props.ViewService({ ordering: this.state.invoice_pagination.ordering, service_order__uuid: ServiceData[i]['uuid'], limit: 10, offset: 0, is_history: true });
                      }}>View or Change Service</button>
                  </div>
                </div>
              </div>
            </div >
          }

        </React.Fragment>
      )
    })

  }


  //Render Residentail Map
  renderMap = (item) => {
    let MAP_OPTIONS = { disableDoubleClickZoom: true, zoomControl: false, mapTypeControl: false, scaleControl: false, streetViewControl: false, rotateControl: false, fullscreenControl: false }
    if (item.service_address.geo_location) {
      return (
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY }}
          options={MAP_OPTIONS}
          defaultCenter={{ lat: item?.service_address?.geo_location?.latitude, lng: item?.service_address?.geo_location?.longitude }}
          defaultZoom={15}
        >

          <MarkePin
            lat={item?.service_address?.geo_location?.latitude?.toString()}
            lng={item?.service_address?.geo_location?.longitude?.toString()} />
        </GoogleMapReact>
      )
    }

  }

  //render Active Service
  renderActiveService = () => {
    let { ServiceData, currentService, role } = this.state;

    return map(ServiceData, (item, i) => {
      if (currentService === ServiceData[i]['uuid']) {
        let _markers = [], multiple_locations = item?.commercial_detail?.multiple_locations, address = item?.service_address
        if (multiple_locations && multiple_locations !== "None") {
          let locations = multiple_locations?.split('MULTIPOINT')[1]
          locations = locations?.trim().substr(1, locations.trim().length - 2)
          let temp = locations?.split(', ')
          map(temp, (obj) => _markers.push({ lat: obj.split(' ')[0], lng: obj.split(' ')[1] }))
        } else if (!isEmpty(address) && !isEmpty(address?.geo_location)) {
          _markers = [{ lat: address?.geo_location?.latitude, lng: address?.geo_location?.longitude }]
        }

        let frequency = [];
        map(item?.frequency_type?.split(', '), x => x && frequency.push(FREQUENCY_MAPPING[x]))

        const cleaning_areas = item?.calculated_price?.cleaning_areas;
        let arr_cleaning_area = [];
        if (!isEmpty(cleaning_areas) && !isEmpty(cleaning_areas.items)) {
          map(cleaning_areas.items, (item) => {
            if (item.price !== 0) {
              arr_cleaning_area.push(item.area);
            }        
          });
        }

        return (
          <React.Fragment key={i}>
            <div className="col-md-6 col-xl-4 col-lg-4 mb-20" key={i}>
              {role.includes('commercial_customer') ?
                <div className="ccard">
                  {
                    !isEmpty(_markers) ?
                      <div className="cmap">
                        <CustomMap markers={_markers} />
                      </div> : ''
                  }
                  <div className="cbody">
                    <h5>
                      <span className="adpin"></span>&nbsp; &nbsp;
                      <span>{item.service_address?.address},{item.service_address?.city},{item.service_address?.state} {item.service_address?.zip_code}</span>
                    </h5>
                    <div className="sdetail d-flex ">
                      <div className="scell">
                        <strong>Next Service</strong>
                        <p> {item.next_service_date ? moment(item.next_service_date).format('ddd, MMM DD') : ''}</p>
                      </div>
                      <div className="scell">
                        <strong>Frequency</strong>
                        <p>{!isEmpty(frequency) ? frequency?.join(', ') : ''}</p>
                      </div>
                      <div className="scell">
                        <strong># of Homes</strong>
                        <p>{item?.commercial_detail?.home_count ? item?.commercial_detail?.home_count : ''}</p>
                      </div>
                    </div>
                    <div className="sdetail">
                      <div className="subs">
                        <strong>Service Needs</strong>
                        <span className=" d-flex justify-content-between">
                          <div>
                            {map(item?.commercial_detail?.line_items, (x, i) => {
                              if (x.item_type === 'service') {
                                return (

                                  <p key={i}> {`${status2[x.item]}`}</p>
                                )
                              }
                            }) }
                          </div>
                        </span>
                      </div>
                    </div>
                    <div className="sdetail" style={{borderBottom: "0px solid #e1e1e5"}}>
                      <div className="subs">
                        <strong>Products Needs</strong>
                        <span className=" d-flex justify-content-between">
                          <div>
                            {map(item?.commercial_detail?.line_items, (x, i) => {
                              if (x.item_type === 'product') {
                                return (
                                  <p key={i}> {`${status2[x.item]}`}</p>
                                )
                              }
                            }) }
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                :

                <div className="ccard">
                  {item.service_address.geo_location ?
                    <div className="cmap">
                      {this.renderMap(item)}
                    </div>
                    : ''}
                  <div className="cbody">
                    <h5>
                      <span className="adpin"></span>&nbsp; &nbsp;
                      <span>{item.service_address.address},{item.service_address.city},{item.service_address.state} {item.service_address.zip_code}</span>
                    </h5>
                    <div className="sdetail d-flex ">
                      <div className="scell">
                        <strong>Next Service</strong>
                        <p>{item.next_service_date ? moment(item.next_service_date).format('ddd, MMM DD') : ''}</p>
                      </div>
                      <div className="scell">
                        <strong>Frequency</strong>
                        <p>{FREQUENCY_MAPPING[item.calculated_price.frequency] && FREQUENCY_MAPPING[item.calculated_price.frequency]}</p>

                      </div>
                      <div className="scell">
                        <strong># of Dogs</strong>
                        <p>{item.calculated_price.pet_count}</p>
                      </div>
                    </div>

                    <div className="sdetail">
                      <div className="subs">
                        <strong>Subscription</strong>
                        <span className=" d-flex justify-content-between">
                          <p>
                            {FREQUENCY_MAPPING[item.calculated_price.frequency]}&nbsp; service, {PROPERTY_TYPE_MAPPING[item.calculated_price.property_type] && PROPERTY_TYPE_MAPPING[item.calculated_price.property_type]}, {item.calculated_price.pet_count} dogs</p>
                          <strong>${item.calculated_price.service_base_price}</strong>
                        </span>
                      </div>

                      <div className="subs">
                        <strong>Cleaning Areas</strong>
                        <span className=" d-flex justify-content-between">
                          <p>{arr_cleaning_area.length > 0 ? arr_cleaning_area.join(', ') : 'NA'}</p>
                          <strong>${item?.calculated_price?.cleaning_areas?.total_price}</strong>
                        </span>
                      </div>

                      <div className="subs">
                        <strong>Add On</strong>
                        <span className=" d-flex justify-content-between">

                          {item.calculated_price.recurring_add_ons.recurring_addon_items.length > 0 ?
                            <React.Fragment>
                              <p>
                                {map(item.calculated_price.recurring_add_ons
                                  && item.calculated_price.recurring_add_ons.recurring_addon_items, (a) => {
                                  return `${a.name}, `
                                })}
                               ({FREQUENCY_MAPPING[item.calculated_price.frequency]})
                              </p>
                              <strong>${item.calculated_price.recurring_add_ons.total_recurring_addon_cost}</strong>
                            </React.Fragment> : '-'}

                        </span>
                      </div>
                    </div>
                    <React.Fragment>
                      <div className="vtotal  d-flex justify-content-between">
                        <strong>Total per visit</strong>
                        <strong>${item.calculated_price.total_price_per_service}</strong>
                      </div>
                      <div className="btn-grp d-flex justify-content-between">
                        <button type="button" className="btn btn--secondary d-flex justify-content-center" onClick={() => {
                          this.props.tabChange(6);
                          localStorage.setItem('is_edit_request', JSON.stringify({ 'is_edit_request': true }));
                        }}>Edit &nbsp;<span className="hide-md">Service</span></button>
                        <button type="button" className="btn btn--secondary d-flex justify-content-center"
                          onClick={() => {
                            this.props.getPauseService({ 'service_order__uuid': item.uuid });
                            this.setState({
                              is_pause_service: true, loader: true, pause_service: {
                                'pause_from': null,
                                'pause_to': null,
                                'suspend_until_manual': false,
                                'understand_pause_func': false
                              },
                            })
                            this.ValidateForm();
                          }}>Pause &nbsp;<span className="hide-md">Service</span></button>
                      </div>
                    </React.Fragment>
                  </div>
                </div>
              }

              <div className="hide-md">
                {this.renderServiceDetails()}
              </div>
            </div>
          </React.Fragment>

        )
      }
    })

  }

  //Table Server side pagination
  handleTableChange = (pagination) => {
    let invoice_pagination = this.state.invoice_pagination;
    invoice_pagination = Object.assign(this.state.invoice_pagination, { 'current': pagination.current });
    this.setState({
      invoice_pagination,
      loader: true,
    })

    this.props.ViewService({ ordering: this.state.invoice_pagination.ordering, offset: (pagination.current * 10) - 10, limit: 10, service_order__uuid: this.state.currentService });
  }

  //on pause service change
  onPauseServiceChange = (e, name) => {
    let { pause_service } = this.state;
    Object.assign(pause_service, { [name]: e })
    if (name === 'pause_from') {
      Object.assign(pause_service, { 'pause_to': null })
    }
    this.setState({
      pause_service
    })
    this.ValidateForm();
  }


  //pause service
  pauseService = () => {
    let { pause_service, currentService, } = this.state;
    let data = {
      service_order_uuid: currentService,
      understand_pause_func: pause_service.understand_pause_func,
      pause_from: moment(pause_service.pause_from).format('YYYY-MM-DD'),
      pause_to: moment(pause_service.pause_to).format('YYYY-MM-DD'),
      suspend_until_manual: pause_service.suspend_until_manual
    }
    if (pause_service.suspend_until_manual) {
      data.pause_to = null
    }
    this.setState({ loader: true })
    this.props.pauseService(data);

  }

  //render pause service list
  renderPausesdServices = () => {
    let { pauseServiceList } = this.state;
    return map(pauseServiceList, (item, i) => {
      return (
        <React.Fragment key={i}>
          <div className=" pause-row d-flex justify-content-between">
            <div className="">
              <span className="mb-0 btext">{moment(item.pause_from).format('ddd, MMM DD')} to {moment(item.pause_to).format('ddd, MMM DD')}
                {/* <React.Fragment>
                  &nbsp;&nbsp;&nbsp;{item.suspend_until_manual ?
                    <Popconfirm
                      title="Are you sure Resume this pause service?"
                      onConfirm={() => {
                        this.props.deletePauseService(item.uuid)
                        this.setState({ loader: true });
                        this.setState({
                          pauseServiceList: reject(pauseServiceList, function (el) { return el.uuid === item.uuid })
                        })
                      }}
                      okText="Yes"
                      cancelText="No"
                    > <u>Resume Service Now</u> </Popconfirm> :}

                </React.Fragment> */}

              </span>
              <p className="mb-0">{item.reason}</p>
            </div>
            <Popconfirm
              title="Are you sure delete this pause service?"
              onConfirm={() => {
                this.props.deletePauseService(item.uuid)
                this.setState({ loader: true });
                this.setState({
                  pauseServiceList: reject(pauseServiceList, function (el) { return el.uuid === item.uuid })
                })
              }}
              okText="Yes"
              cancelText="No"
            >
              <img src={trash} className="cursor_pointer" alt="" />
            </Popconfirm>

          </div>
        </React.Fragment>
      )
    })

  }

  // render service history table
  serviceHistoryTable = () => {

    return (
      <React.Fragment>
        <Table
          rowKey={record => record.uuid}
          rowClassName={(record) => { if (record.status === 'cancelled') { return 'cancelled' } }}
          dataSource={this.state.viewMyService}
          pagination={this.state.invoice_pagination}
          onChange={this.handleTableChange}
          columns={DataTable.Service(this)}
          onRow={(r) => ({
            onClick: () => {

              this.setState({ is_feedback: true, current_history: r });
              let { feedback } = this.state;

              Object.assign(feedback, { 'rating': r.rating, 'comment': r.comment })
              this.setState({ feedback })
            },
          })}
          className="table invoice_table"
        />
        <div className="show-md">
          {this.renderServiceDetails()}
        </div>

      </React.Fragment>)
  }


  //Service history order
  onServiceHistoryOrder = (e) => {
    let { invoice_pagination, currentService } = this.state;
    this.setState({
      loader: true
    })
    Object.assign(invoice_pagination, { 'ordering': e, current: 1 })
    this.setState({ invoice_pagination });
    let data = { 'service_order__uuid': currentService, 'ordering': e, 'limit': 10, 'offset': 0, 'is_history': true }


    if (e === '') {
      delete data.ordering;
    }
    this.props.ViewService(data);

  }

  // Pause Service Validation
  ValidateForm = () => {
    let { pause_service } = this.state;

    const PauseServiceSchema = yup.object().shape({

      pause_service: yup.object().shape(
        {
          pause_from: yup.string().required(""),
          // pause_to: yup.string().when('suspend_until_manual', {is: false, then: yup.string().required('Time field is required') })
        }
      ),

    })
    const PauseServiceData = { pause_service }
    // check validity
    let IsValid;
    var self = this;
    PauseServiceSchema.isValid(PauseServiceData)
      .then(function (valid) {
        IsValid = valid
      });
    setTimeout(() => {
      if (IsValid) {

        self.setState({
          is_submit_btn_active: false
        })

        //condition for pause to
        if (!pause_service.suspend_until_manual && pause_service.pause_to === null) {
          self.setState({
            is_submit_btn_active: true
          })
        }
        else {
          self.setState({
            is_submit_btn_active: false
          })
        }
      }
      else {
        PauseServiceSchema.validate(PauseServiceData, { abortEarly: false })
          .catch(function () {
            self.setState({
              is_submit_btn_active: true
            })
          });
      }
    }, 100);
  }


  //render Service Details
  renderServiceDetails = () => {
    let { ServiceData, currentService, role } = this.state;
    let BAGS = {
      header_bags: "Header Bags",
      roll_bags: 'Roll Bags',
      dont_know: 'Dont Know',
    }
    return map(ServiceData, (item, i) => {
      if (currentService === ServiceData[i]['uuid']) {
        let url = item?.commercial_detail?.pet_waste_station_map?.split('?') || [];
        let pet_waste_file_name = url?.[0]?.split('/')?.[url?.[0]?.split('/')?.length - 1]

        const bagType = map(item?.commercial_detail?.bag_type, (x) => {
          return `${BAGS[x]}`
        })

        return (
          <React.Fragment key={i}>
            <div className="ccard info-card">
              <div className="cbody">
                <h5>Service Details</h5>
                {
                  role.includes('commercial_customer') ?

                    <div className="sdetail">
                      <div className="subs mb-10">
                        <strong>Stations already installed?:</strong> {item?.commercial_detail?.is_pet_waste_stations_installed ? 'Yes' : 'No'}
                      </div>
                      {item?.commercial_detail?.is_pet_waste_stations_installed ?
                        <React.Fragment>
                          <div className="subs mb-10">
                            <strong>Number of exisiting PWT:&nbsp;</strong> {item?.commercial_detail?.existing_pet_waste_stations_count}
                          </div>
                          <div className="subs mb-10">
                            <strong>PWT Location Map:&nbsp;</strong>
                            {item?.commercial_detail?.pet_waste_station_map ?
                              <a rel="noopener noreferrer" style={{color: 'black'}}
                                href={item.commercial_detail.pet_waste_station_map} target="_blank"><u>{pet_waste_file_name}</u></a>
                              : ''}
                          </div>
                          <div className="subs mb-10">
                            <strong>Types of Bags:&nbsp;</strong>{!isEmpty(bagType) ? bagType?.join(', ') : ''}
                          </div>
                        </React.Fragment>
                        : <div className="subs mb-10">
                          <strong>How many stations would you like installed?:</strong>{item?.commercial_detail?.new_pet_waste_stations_interested ? item?.commercial_detail?.new_pet_waste_stations_interested : '-'}
                        </div>
                      }

                      <div className="subs">
                        <strong>Additional Comments:</strong>   {item?.commercial_detail?.additional_comments ? item?.commercial_detail?.additional_comments : '-'}
                      </div>
                    </div>

                    :
                    <React.Fragment>
                      <div className="sdetail">
                        <div className="subs mb-10">
                          <strong>Cleaning areas:</strong> {map(item.calculated_price.recurring_add_ons
                            && item.area_to_clean, (a) => {
                            return `${a}, `
                          })}
                        </div>
                      </div>
                      <div className="sdetail">
                        <div className="subs mb-10">
                          <strong>Cleaning notes: </strong>{ServiceData[i].cleaning_notes}
                        </div>
                      </div>
                      <div className="sdetail">
                        <div className="subs">
                          <strong>Scooped waste disposal area:</strong>  {ServiceData[i].disposal_location}.
                        </div>
                      </div>

                    </React.Fragment>
                }

              </div>
            </div>

            {
              role.includes('commercial_customer') ?
                '' :
                <div className="ccard info-card">
                  <div className="cbody">
                    <h5>Need an extra service?</h5>
                    <div className="sdetail">
                      <div className="subs">
                        <p>Request a one-time cleaning for a special occasion</p>
                      </div>
                      <div className="btn-grp">
                        <button type="button"
                          className="btn btn--secondary w-100"
                          onClick={() => {
                            this.props.tabChange(6);
                            localStorage.setItem('is_request_one_time', JSON.stringify({ 'is_request_one_time': true }));
                          }}
                        >Request one-time service</button>


                      </div>
                    </div>
                  </div>
                </div>}
          </React.Fragment>

        )

      }
    })
  }

  render() {
    let { is_feedback, is_pause_service,
      view_my_service, loader, service_address, pause_service,
      current_history, feedback, invoice_pagination, is_submit_btn_active, role, temp_hide_specific_elmement } = this.state;

    return (
      <React.Fragment>
        <div className="breadcrumb">
          {view_my_service && temp_hide_specific_elmement ?
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <ul>
                    <li><a href="/#" onClick={(e) => {
                      e.preventDefault();
                      //Call service order API
                      // this.props.getServiceOrder();
                      this.setState({
                        loader: true
                      })
                      let invoice_pagination = this.state.invoice_pagination;

                      invoice_pagination = Object.assign(this.state.invoice_pagination, { 'current': 1 });
                      this.setState({ service_address: {}, view_my_service: false, invoice_pagination })

                    }}>Services</a></li>
                    <li><a href="/#">{service_address?.address}, {service_address?.city}, {service_address?.state} {service_address?.zip_code}</a></li>
                  </ul>
                </div>
              </div>
            </div>
            : ''}

        </div>

        <div className="my_account_wrapper">
          
        { !temp_hide_specific_elmement ?
            <div className="my_services">
              <div className="container">
                <div className="row">
                <div className="details">
                <h3>This section is under construction! </h3>
                <h3><br></br>Coming soon!</h3>
                </div>
                </div>
              </div>
            </div>
            : ''}
          {/* All service Listing */}
          {!view_my_service && temp_hide_specific_elmement ?
            <div className="my_services">
              <div className="container">
                <div className="row">
                  {this.renderAllService()}
                  <div className="col-md-6 col-xl-4 col-lg-4 mb-20">
                    <div className="blank_box">
                      <div className="details">
                        {
                          role.includes('commercial_customer') ?
                            <h5>Create an additional proposal</h5>
                            :
                            <h5>Create an additional service</h5>
                        }
                        {
                          role.includes('commercial_customer') ?
                            <p>This can be a new service proposal, or an additional proposal at the same community.</p>
                            :
                            <p>This can be a new service, an additional service or a one-time extra service at any address.</p>
                        }
                        {
                          role.includes('commercial_customer') ? <button className="btn btn--secondary lg-btn w-100">Request New Proposal</button> :

                            <button className="btn btn--secondary lg-btn w-100" onClick={() => {

                              this.props.history.push('/');
                              localStorage.setItem('is_edit', JSON.stringify({ 'is_edit': true }));
                              localStorage.setItem('is_property_type', JSON.stringify({ property_type: 'residential' }));

                            }}>Add New Service</button>
                        }
                      </div>
                      <img className="doodle" src={peeking_doodle} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            : ''}

          {/* single ServiceListing */}
          {view_my_service && temp_hide_specific_elmement ?
            <div className="my_services">
              <div className="container">
                <div className="row">

                  {this.renderActiveService()}

                  <div className="col-md-12 col-xl-8 col-lg-8 aside-full">
                    <Collapse defaultActiveKey={['1']} expandIconPosition="right" expandIcon={({ isActive }) => <img src={Path} alt="" className={isActive ? '' : 'icon_rotate'} />}
                    >
                      <Panel className="primary" header="View Service History" key="1">
                        <div className="tablebody service_history_table">
                          <div className="table-header d-flex justify-content-between">
                            <h5>Service History</h5>
                            <div className="sorting d-flex no-bdr">
                              <span><img src={sort} alt="" /> SORT:</span>
                              <Select
                                className="sort_by"
                                placeholder="Latest First"
                                value={invoice_pagination.ordering}
                                onChange={(e) => { this.onServiceHistoryOrder(e) }}
                                suffixIcon={<img src={chevron} alt="" />}
                                dropdownClassName="sort-select"
                                virtual={false}
                                defaultValue="scheduled_time"
                              >
                                <Option value="scheduled_time"><i className="las la-long-arrow-alt-up sort_by_icon"></i>Latest First</Option>
                                <Option value="-scheduled_time"><i className="las la-long-arrow-alt-down sort_by_icon"></i>Oldest First</Option>
                              </Select>
                            </div>
                          </div>
                          {this.serviceHistoryTable()}
                        </div>
                      </Panel>
                    </Collapse>
                  </div>
                </div>
              </div>
            </div>
            : ''}



          {/* Modal */}
          <Modal
            className="service_modal"
            visible={is_feedback}
            footer={[
              <Button
                key="cancel"
                className="btn btn-outline--primary"
                onClick={() => { this.setState({ is_feedback: false, current_history: {}, feedback: { 'rating': 0, 'comment': '' } }) }}
              >Close</Button>,
              <Button key="submit"
                onClick={
                  () => {
                    let params = {
                      uuid: current_history.uuid,
                      rating: feedback.rating,
                      comment: feedback.comment
                    }
                    Promise.all([
                      this.props.addReviewInService(params),

                    ]);


                    this.setState({ loader: true })
                  }
                }
                className="btn btn--secondary"
              >Submit Feedback</Button>
            ]}
          >
            <div className="moday_body">

              <h6 className="modal-head">View Service History</h6>
              <span className="btext"><strong> {moment(current_history.scheduled_time).format('ddd, MMM DD')}  &nbsp; &nbsp; {moment(current_history.scheduled_time).format('hh:mm A')}</strong></span>
              <p>Weekly recurring service  ·  Serviced by Jim R.</p>
              <div className="shistory d-flex">
                {current_history?.technician ?
                  <div className="profile-wrap">
                    <figure>
                      {current_history?.technician?.photo ?
                        <img src={current_history?.technician?.photo} alt="" />
                        : ''}
                    </figure>
                  </div>
                  : ''}
                {current_history?.technician &&Object.keys(current_history?.technician).length > 0 ?
                  <div className="profile-info">
                    <div className="profile-detail">
                      <strong>{current_history?.technician?.first_name} {current_history?.technician?.last_name}&nbsp;&nbsp; . &nbsp;&nbsp;Technician</strong>
                      <p><i>{current_history?.technician?.description}</i></p>
                    </div>
                  </div>
                  : ''}
              </div>
              <div className="profile-body">
                {current_history?.technician_comment ? <p>“{current_history.technician_comment}”</p> : ''}
              </div>
              <figure className="petimg">
                {current_history.technician_image ?
                  <img src={current_history.technician_image} alt="" /> : ''}
              </figure>
              <div className="modal-form">
                <div className="form-group">
                  <span className="btext"><strong>Your Feedback</strong></span>
                  <Rate className="mb-10"
                    allowHalf
                    value={feedback.rating}
                    onChange={(e) => {
                      Object.assign(feedback, { 'rating': e })
                      this.setState({ feedback })

                    }} />
                  <textarea className="form--control"
                    onChange={(e) => {
                      Object.assign(feedback, { 'comment': e.target.value });
                      this.setState({ feedback })

                    }} value={feedback.comment || ''} placeholder="Give your technician some feedback."></textarea>
                </div>
              </div>
            </div>
          </Modal>

          {/* Pause Service Modal */}
          <Modal
            className="service_modal"
            visible={is_pause_service}
            footer={[
              <Button key="cancel"
                className="btn btn-outline--primary" onClick={() => {
                  this.setState({
                    is_pause_service: false,
                    is_pause_service_checked: false,
                    suspend_until_manual: false,
                    pause_service: {
                      'pause_from': null,
                      'pause_to': null,
                      'suspend_until_manual': false,
                      'understand_pause_func': false
                    },
                  })

                }}>Cancel</Button>,
              <Button
                key="submit"
                className="btn btn--secondary"
                disabled={is_submit_btn_active}
                onClick={() => { this.pauseService() }}
              >Pause Service</Button>
            ]}
          >
            <div className="moday_body">
              <h6 className="modal-head">Pause Service</h6>

              <div className="modal-form">
                <form>
                  <div className="form-group d-flex sm-flex-col">
                    <div className="halfitem">
                      <label>From</label>
                      <DatePicker
                        className="form--control dog_date_picker"
                        format="MM/DD/YYYY"
                        disabledDate={(current) => { return current && current <= moment().endOf('day'); }}
                        value={pause_service.pause_from}
                        onChange={(e) => { this.onPauseServiceChange(e, 'pause_from') }}
                        inputReadOnly
                        allowClear={false}
                        dropdownClassName="dog_date_dropdown"
                        placeholder="MM/DD/YYYY" />
                      {/* <span className="successmsg link"
                        onClick={() => {
                          pause_service = Object.assign(pause_service, {
                            'suspend_until_manual': !this.state.pause_service.suspend_until_manual,
                            'pause_to': null
                          })
                          this.setState({
                            pause_service,
                            suspend_until_manual: !this.state.suspend_until_manual
                          });
                          this.ValidateForm();
                        }}>Suspend until manual restart</span> */}
                    </div>
                    <div className="halfitem">
                      <label>To</label>
                      <DatePicker
                        className="form--control dog_date_picker"
                        format="MM/DD/YYYY"
                        disabled={pause_service.suspend_until_manual}
                        value={pause_service.pause_to}
                        disabledDate={(endValue) => { return endValue.valueOf() <= moment(moment(pause_service.pause_from, 'DD/MM/YYYY')).valueOf(); }}
                        onChange={(e) => { this.onPauseServiceChange(e, 'pause_to') }}
                        inputReadOnly
                        allowClear={false}
                        dropdownClassName="dog_date_dropdown"
                        placeholder="MM/DD/YYYY" />
                    </div>
                  </div>
                  {/* <span className="successmsg link mb-20"
                    onClick={() => {
                      pause_service = Object.assign(pause_service, {
                        'suspend_until_manual': !this.state.pause_service.suspend_until_manual,
                        'pause_to': null
                      })
                      this.setState({
                        pause_service,
                        suspend_until_manual: !this.state.suspend_until_manual
                      });
                      this.ValidateForm();
                    }}>Suspend until manual restart</span> */}
                  {/* <div className="form-group">
                    <Select
                      className="sort_by"
                      value={pause_service.reason || undefined}
                      placeholder="Choose a reason for pausing this service"
                      onChange={(e) => { this.onPauseServiceChange(e, 'reason') }}
                      suffixIcon={<img src={chevron} alt="" />}
                    >
                      <Option value="Reason 1">Reason 1</Option>
                      <Option value="Reason 2">Reason 2</Option>
                      <Option value="Reason 3">Reason 3</Option>
                    </Select>
                  </div> */}
                  <div className="form-group">
                    <div className="checkbox_wrapper orange-check">
                      <input
                        id="understand_pause_func"
                        checked={pause_service.understand_pause_func}
                        onChange={(e) => {
                          pause_service = Object.assign(pause_service, { 'understand_pause_func': e.target.checked });
                          this.setState({
                            pause_service
                          })
                          this.ValidateForm();
                        }}
                        type="checkbox" className="mb-0" />
                      <label className="primary" htmlFor="understand_pause_func">My dog (s) will not be using the yard during this time. I understand there may be an additional fee if waste accumulates while my service is paused.
                      </label>
                    </div>

                  </div>
                  <hr />
                  <h4 className="mb-10">Existing Pauses</h4>

                  {this.renderPausesdServices()}

                </form>
              </div>
            </div>
          </Modal>
        </div >
        {
          loader ?
            <div className='loader_wrapper'>
              < div className='loader07' ></div >
            </div >
            : ''
        }
      </React.Fragment>
    );
  }
}

export default MyServices;